import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/data';

export default function HotArticlesSection() {
  const featuredArticles = hotArticles.filter((a) => a.featured);
  const normalArticles = hotArticles.filter((a) => !a.featured);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12 md:mb-16">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              热门文章
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
              精选使用指南
            </h2>
            <p className="text-sm text-foreground-600">
              从入门到精通，掌握黄瓜视频的所有玩法
            </p>
          </div>
          <Link
            to="/category/shiyong-jiqiao"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部文章
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="w-full sm:w-[220px] lg:w-[200px] h-[200px] sm:h-auto flex-shrink-0 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 p-5 flex flex-col justify-center">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-500">{article.date}</span>
                    <span className="text-xs text-foreground-500">{article.readTime}阅读</span>
                  </div>
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {normalArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="h-[180px] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime}阅读</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}